// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".question-inset-box[data-v-3a785fbc]{background:#fff;border-radius:1rem;padding:10px 25px}@media screen and (max-width:768px){.question-inset-box[data-v-3a785fbc]{padding:5px 0}}.question-inset-box.standalone[data-v-3a785fbc]{background:transparent;box-shadow:none;padding:0}.question-inset-box.standalone .action-row[data-v-3a785fbc]{padding-top:25px}.action-row[data-v-3a785fbc]{justify-content:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
